import styles from "./Signin.module.scss";
import React from "react";
import Form from "react-bootstrap/Form";
import useSignin from "./useSignin";

const Signin = () => {
  const {
    logingIn,
    handleLogin,
    error,
    email,
    password,
    updateEmail,
    updatePassword
  } = useSignin();

  return <div className={styles.loginContainer}>
    <div className={styles.formContainer}>
      <div className={styles.loginForm}>
        <div className={styles.logo}>
          <img src="/android-chrome-192x192.png" alt="Logo"/>

          Willaime
        </div>

        {error && <div className={styles.error}>{error}</div>}

        <Form onSubmit={handleLogin}>
          <Form.Group className="mb-2" controlId="login-email">
            <Form.Control
              type="text"
              name="email"
              value={email}
              onChange={updateEmail}
              placeholder="Adresse email"
              disabled={logingIn}
            />
          </Form.Group>
          <Form.Group className="mb-2" controlId="login-password">
            <Form.Control
              type="password"
              name="password"
              value={password}
              onChange={updatePassword}
              placeholder="Mot de passe"
              disabled={logingIn}
              autoComplete="on"
            />
          </Form.Group>

          <button className={styles.submitBtn} type="submit" disabled={logingIn}>Connexion</button>
        </Form>
      </div>
    </div>
  </div>;
};

export default Signin;
